document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.getElementById('CollectionWrapper');
    if (!wrapper) return;

    const sectionId = wrapper.dataset.sectionId;

    // registrarNoHistorico = false quando quem chamou foi o botão voltar/avançar
    const updateCollection = async (url, registrarNoHistorico = true, rolarProTopo = false) => {
        // Adiciona o parâmetro section_id para a Section Rendering API
        const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;

        const productGrid = document.getElementById('ProductGrid');
        if (productGrid) productGrid.style.opacity = '0.5';

        let doc;
        try {
            const response = await fetch(fetchUrl);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = await response.text();
            doc = new DOMParser().parseFromString(html, 'text/html');
            if (!doc.getElementById('ProductGridWrapper')) throw new Error('Resposta sem a grade');
        } catch (erro) {
            // Sem rede ou resposta estranha: abre a página do jeito normal em vez de travar a grade
            console.error(erro);
            window.location.href = url;
            return;
        }

        // Substitui o bloco inteiro (Grid + Paginação)
        const newGridWrapper = doc.getElementById('ProductGridWrapper');
        const newProductCount = doc.getElementById('ProductCount');
        const newFilterForm = doc.getElementById('FilterForm');
        document.getElementById('ProductGridWrapper').innerHTML = newGridWrapper.innerHTML;
        if (newProductCount) document.getElementById('ProductCount').innerHTML = newProductCount.innerHTML;
        // Filtros também: opções e valores escolhidos acompanham a página mostrada
        const filterForm = document.getElementById('FilterForm');
        if (newFilterForm && filterForm) {
            filterForm.innerHTML = newFilterForm.innerHTML;
            bindSelectEvents();
        }

        if (registrarNoHistorico) window.history.pushState({ path: url }, '', url);

        if (rolarProTopo) {
            const topo = wrapper.getBoundingClientRect().top;
            if (topo < 0) wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // RE-BIND: Como destruímos o HTML anterior, precisamos re-anexar os eventos de clique na paginação
        bindPaginationEvents();
    };

    const bindPaginationEvents = () => {
        document.querySelectorAll('.pager a').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                updateCollection(link.getAttribute('href'), true, true);
            });
        });
    };

    // Toggle de animação para os selects de filtro (contorna o bug do :focus nativo)
    const bindSelectEvents = () => {
        document.querySelectorAll('.fselect').forEach(select => {
            // Remove os event listeners antigos caso estejamos re-bindando após um fetch
            const newSelect = select.cloneNode(true);
            select.parentNode.replaceChild(newSelect, select);

            newSelect.addEventListener('click', () => newSelect.classList.toggle('is-open'));
            newSelect.addEventListener('blur', () => newSelect.classList.remove('is-open'));
            newSelect.addEventListener('change', () => newSelect.classList.remove('is-open'));
        });
    };

    // Filtros — só vincula se o formulário existir (coleções sem filtros não o renderizam)
    const filterForm = document.getElementById('FilterForm');
    if (filterForm) {
        // Usamos delegação de eventos para o form para evitar problemas ao substituir os elementos internos
        filterForm.addEventListener('change', () => {
            const formData = new FormData(filterForm);
            const params = new URLSearchParams(formData);
            updateCollection(`${window.location.pathname}?${params.toString()}`);
        });
    }

    // Voltar/avançar do navegador: mostra a página do endereço atual
    window.addEventListener('popstate', () => {
        updateCollection(window.location.pathname + window.location.search, false);
    });

    bindPaginationEvents();
    bindSelectEvents();
});
